import React from 'react'
import { createPortal } from 'react-dom'

export default function LoadingModal({ isOpen, loadingText }) {
  if (!isOpen) return null

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50"></div>

      <dialog
        open
        className="mdl-dialog mdl-dialog--500"
        style={{ zIndex: 99, textAlign: 'center' }}
        aria-modal="true"
        aria-labelledby="dialog_label"
        aria-describedby="dialog_desc">
        {loadingText && (
          <div className="mdl-dialog__title mdl-grid block--full">
            <div className="mdl-cell mdl-cell--12-col text--med-lg" id="dialog_label">
              {loadingText}
            </div>
          </div>
        )}
      </dialog>
    </div>,
    document.body
  )
}
